import { z } from 'zod';

const convertToInteger = (value: unknown): number | null => {
  if (typeof value === 'string') {
    const parseVal = parseInt(value, 10);
    if (Number.isNaN(parseVal)) {
      return null;
    }
    return parseVal;
  }
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return value;
  }
  return null;
};

export const stringToIntegerSchema = z.preprocess(convertToInteger, z.number());
